import LoginForm from "@/features/auth/login/components/LoginForm";

export default function Login() {
  return <LoginForm />;
}
